import { render, staticRenderFns } from "./ReviewExpert.vue?vue&type=template&id=5d0b59d5&scoped=true&"
import script from "./ReviewExpert.vue?vue&type=script&lang=js&"
export * from "./ReviewExpert.vue?vue&type=script&lang=js&"
import style0 from "./ReviewExpert.vue?vue&type=style&index=0&id=5d0b59d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b59d5",
  null
  
)

export default component.exports